import React, { useState } from "react";
import { Tables } from "@/lib/supabase/supabaseTypesImport";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "../ui/hover-card";
import { ChatPreviewList } from "./chat-preview-list.component";
import { UnreadFilterToggle } from "./unread-filter-toggle.component";
import { useNavigate } from "react-router-dom";

interface ChatPreviewHoverCardProps {
	children: React.ReactNode;
	channels: Tables<"message_channels">[];
	userId: string;
	organizationId: string;
	onChatInteraction?: () => void;
}

export const ChatPreviewHoverCard: React.FC<ChatPreviewHoverCardProps> = ({
	children,
	channels,
	userId,
	organizationId,
	onChatInteraction,
}) => {
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);

	const handleSelectChannel = (channel: Tables<"message_channels">) => {
		// Notify parent component about chat interaction
		onChatInteraction?.();
		// Close the hover card before navigating
		setOpen(false);
		// Small delay to allow the closing animation to complete
		setTimeout(() => {
			navigate(`/chats/${channel.id}`);
		}, 100);
	};

	// Sort channels by last message time
	const sortedChannels = [...channels].sort((a, b) => {
		const aTime = a.last_message_at ? new Date(a.last_message_at).getTime() : 0;
		const bTime = b.last_message_at ? new Date(b.last_message_at).getTime() : 0;
		return bTime - aTime;
	});

	return (
		<HoverCard
			openDelay={200}
			closeDelay={100}
			open={open}
			onOpenChange={setOpen}
		>
			<HoverCardTrigger asChild>
				{children}
			</HoverCardTrigger>
			<HoverCardContent
				side="right"
				align="center"
				className="w-80 p-0 rounded-lg bg-slate-100"
			>
				<div className="flex items-center justify-between px-3 py-2 border-b border-white">
					<h3 className="text-md font-medium text-gray-900">
						Chats
					</h3>
					<UnreadFilterToggle />
				</div>
				<div className="max-h-[500px] overflow-y-auto rounded-b-lg">
					<ChatPreviewList
						channels={sortedChannels}
						onSelectChannel={handleSelectChannel}
						userId={userId}
						organizationId={organizationId}
					/>
				</div>
			</HoverCardContent>
		</HoverCard>
	);
};